
export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
